import { render, staticRenderFns } from "./BaseBoxSection.vue?vue&type=template&id=78af8e5b&scoped=true"
import script from "./BaseBoxSection.vue?vue&type=script&lang=js"
export * from "./BaseBoxSection.vue?vue&type=script&lang=js"
import style0 from "./BaseBoxSection.vue?vue&type=style&index=0&id=78af8e5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78af8e5b",
  null
  
)

export default component.exports